export const CAMERA_BATCH_RECEIVED = "CAMERA_BATCH_RECEIVED";
export const CAMERA_RECEIVED = "CAMERA_RECEIVED";
